import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeIn, fadeOut } from 'src/app/animations';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { BinderWizardService } from 'src/app/services/sections/binder/binder-wizard.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';

@Component({
	selector: 'virtual-binder-confirmation',
	templateUrl: './virtual-binder-confirmation.component.html',
	styleUrls: ['./virtual-binder-confirmation.component.scss', '../../stylesheets/job-main.scss'],
	animations: [fadeIn(200), fadeOut(200)]
})
export class VirtualBinderConfirmationComponent implements OnInit {

	public isInvalidToken = false;

	constructor(
		private activatedRoute: ActivatedRoute,
		private binderWizardService: BinderWizardService,
		private router: Router
	) { }

	ngOnInit(): void {
		const code = this.activatedRoute.snapshot.paramMap.get('code');

		this.binderWizardService.submitCode(TokenHelper.getToken(this.activatedRoute), code)
			.subscribe(({ token }: {token: string}) => {
				this.router.navigate(['/', token]);
			}, () => {
				this.isInvalidToken = true;
				GlobalSettingsService.isGlobalLoaderLoading = false;
				GlobalSettingsService.isSecondaryLoaderLoading = false;
			});
	}
}
